import { GraphLoginException } from 'common/exceptions/graph/GraphLoginException';
import { GraphLoginResult } from 'common/models/GraphLoginResult';
import { Dialog } from 'common/utils/office-js-helpers/dialog';
import CONFIG from 'config';
import 'core-js/stable';
import $ from 'jquery';
import Mustache from 'mustache';
import '../scss/main.scss';
import * as GraphAuthUtils from '../utils/graphAuthUtils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).$ = (window as any).jQuery = $;

const TAG = 'GRL3: ';

$(render);

Office.onReady(() => {
  console.log(TAG, 'onReady');

  $(async () => {
    try {
      const result = await GraphAuthUtils.handleRedirectPromise();

      if (!result) {
        GraphAuthUtils.loginRedirect();
        return;
      }

      Dialog.close(JSON.stringify(<GraphLoginResult>{ success: true }));
    } catch (error: unknown) {
      Dialog.close(
        JSON.stringify(<GraphLoginResult>{
          success: false,
          error: new GraphLoginException('Microsoft Graph Login Failed', error),
        })
      );
    }
  });
});

let ready = false;
/** Replace placeholders in HTML with values from config.ts */
async function render() {
  if (ready) {
    return;
  }
  ready = true;

  const template = $('body').html();
  const view = CONFIG;
  const rendered = Mustache.render(template, view);

  if (rendered != template) {
    $('body').html(rendered);
  }
}
